import { appraisalProductApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const HOMEVISION_JOB_TYPE_SETTINGS_ACTION_TYPE = createNamedActions(
  'homeVisionJobTypeSettings',
  {
    GET_HOMEVISION_JOB_TYPE_SETTINGS: 'GET_HOMEVISION_JOB_TYPE_SETTINGS',
    CREATE_HOMEVISION_JOB_TYPE_SETTING: 'CREATE_HOMEVISION_JOB_TYPE_SETTING',
    UPDATE_HOMEVISION_JOB_TYPE_SETTING: 'UPDATE_HOMEVISION_JOB_TYPE_SETTING',
  },
);

const homeVisionJobTypeSettingsSchema = new schema.Entity('data', {}, { idAttribute: 'id' });

export const getHomeVisionJobTypeSettingsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await appraisalProductApi.getHomeVisionJobTypeSettings();

  return dispatch({
    type: HOMEVISION_JOB_TYPE_SETTINGS_ACTION_TYPE.GET_HOMEVISION_JOB_TYPE_SETTINGS,
    payload: normalize(data, [homeVisionJobTypeSettingsSchema]).entities.data,
  });
});

export const createHomeVisionJobTypeSettingAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await appraisalProductApi.createHomeVisionJobTypeSetting(params);

    return dispatch({
      type: HOMEVISION_JOB_TYPE_SETTINGS_ACTION_TYPE.CREATE_HOMEVISION_JOB_TYPE_SETTING,
      payload: data,
    });
  },
);

export const updateHomeVisionJobTypeSettingAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await appraisalProductApi.updateHomeVisionJobTypeSetting(params);

    return dispatch({
      type: HOMEVISION_JOB_TYPE_SETTINGS_ACTION_TYPE.UPDATE_HOMEVISION_JOB_TYPE_SETTING,
      payload: data,
    });
  },
);
